export default __webpack_public_path__ + "static/media/Bookmarked-item.2171fb73.svg";